import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';

import { Subscription } from 'rxjs';
import { HardwareService } from '../../modules/door/hardware.service';
import { WindowDoorFacade } from '../../+state/window-door.facade';
import { ConfigurationsService } from '@icc/configurator/shared';

interface SelectBox {
    imagePath: string;
    name: string;
    color: any;
    colorId: string;
}

@Component({
    selector: 'icc-plates-page',
    templateUrl: './plates-page.component.html',
    styleUrls: ['./plates-page.component.scss'],
    standalone: false
})
export class PlatesPageComponent extends PageComponent implements OnInit {
    public title = _('DOOR|Szyldy');
    public options = [];

    plateMainLock$ = this.doorFacade.plateMainLock$;
    plateMainLockBoxSelect: SelectBox | null = null;
    plateAdditionalLock$ = this.doorFacade.plateAdditionalLock$;
    innerPlateAdditionalLock$ = this.doorFacade.innerPlateAdditionalLock$;
    outerPlateAdditionalLock$ = this.doorFacade.outerPlateAdditionalLock$;
    plateMainLockBoxSelect$ = this.doorFacade.plateMainLockBoxSelect$;
    plateAdditionalLockBoxSelect$ = this.doorFacade.plateAdditionalLockBoxSelect$;
    outerPlateAdditionalLockBoxSelect$ = this.doorFacade.outerPlateAdditionalLockBoxSelect$;
    type: 'inner' | 'outer' = 'inner';

    private subscriptions: Subscription[] = [];
    constructor(
        private hardwareService: HardwareService,
        private doorFacade: WindowDoorFacade,
        private configurationsService: ConfigurationsService<'door'>,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            type: 'inner' | 'outer';
        }
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.push(this.doorFacade.plateMainLockBoxSelect$.subscribe((box) => {
            this.plateMainLockBoxSelect = box;
        }));
        if(this.pageData.type) {
           this.type = this.pageData.type;
        }
    }

    changePlateToMainLockOptions() {
        this.hardwareService.openModalPlateOptions();
    }

    selectPlateToMainLock() {
        this.hardwareService.openPlateToMainLockModal();
    }

    changePlateToAdditionalLock() {
        this.hardwareService.openPlateToAdditionalLockModal();
    }

    changeOuterPlateToAdditionalLock() {
        this.hardwareService.openOuterPlateToAdditionalLockModal();
    }

    isPlatesToMainLockButtonDisabled() {
        const platesToMainLock = this.hardwareService.getPlatesToMainLock();
        return platesToMainLock.length <= 1;
    }

    isPlatesToMainLockButton2Disabled(conf = this.configurationsService.conf.Current) {
        const plateId = conf.doorHardware?.plates?.mainLock;
        const platesToMainLock = this.hardwareService.getPlatesToMainLock();
        const selectedPlate = platesToMainLock.find(p => Number(p.id) === Number(plateId));
        const plateColorsLength = selectedPlate.colors_ids?.length;
        return plateColorsLength.length <= 1;
    }

    isPlatesToAdditionalLockButtonDisabled() {
        const platesToAdditionalLock = this.hardwareService.getPlatesToAdditionalLock();
        return platesToAdditionalLock.length <= 1;
    }

    isOuterPlatesToAdditionalLockButtonDisabled() {
        const outerPlatesToAdditionalLock = this.hardwareService.getOuterPlatesToAdditionalLock();
        return outerPlatesToAdditionalLock.length <= 1;
    }
}
